import React, { useEffect, useContext } from 'react';

import GlobalContext from 'GlobalContext';

import Tabs from 'components/shared/tabs';
import Card from 'components/new-card/Card';
import BackIcon from 'components/shared/back-arrow-icon';

import AsyncTab from './tabs/async';
import AboutView from './tabs/about';
import LearnView from './tabs/learn';
import EventsTab from './tabs/events';
import ClassesTab from './tabs/classes';
import FunctionsTab from './tabs/functions';
import VariablesTab from './tabs/variables';

import './JavaScriptView.scss';

const tabs = [
  {
    key: 0,
    index: 0,
    text: 'About',
    content: <AboutView />,
  },
  {
    key: 1,
    index: 1,
    text: 'Learn',
    content: <LearnView />,
  },
  {
    key: 2,
    index: 2,
    text: 'Variables',
    content: <VariablesTab />,
  },
  {
    key: 3,
    index: 3,
    text: 'Functions',
    content: <FunctionsTab />,
  },
  {
    key: 4,
    index: 4,
    text: 'Classes',
    content: <ClassesTab />,
  },
  {
    key: 5,
    index: 5,
    text: 'Events',
    content: <EventsTab />,
  },
  {
    key: 6,
    index: 6,
    text: 'Async',
    content: <AsyncTab />,
  },
];

const InfobookJavaScriptView = () => {
  const { jsViewTab, setJsViewTab } = useContext(GlobalContext);

  const updateJsTab = (tab) => {
    localStorage.setItem('jsTab', tab);
    setJsViewTab(tab);
  };

  useEffect(() => {
    const savedTab = localStorage.getItem('jsTab');

    if (savedTab) {
      setJsViewTab(savedTab);
    }
  }, []);

  return (
    <div className='javascript-view'>
      <Card type="static" headerText="JavaScript" icon={<BackIcon />}>
        <Tabs tabs={tabs} activeTab={jsViewTab} setActiveTab={updateJsTab} />
      </Card>
    </div>
  );
};

export default InfobookJavaScriptView;
